import { render, staticRenderFns } from "./GalleryIndex.vue?vue&type=template&id=cd4345ea"
import script from "./GalleryIndex.vue?vue&type=script&lang=js"
export * from "./GalleryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports